import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "form" ];

  update() {
    $(this.formTarget).submit()
  }
}
